import React, { useState } from "react";
import { Checkbox } from "antd";
import { useSnackbar } from "notistack";
import Datepicker from "../reusable/datePicker"

import { usePet, useToggle, notifOps } from "../../modules";

import Modal from "../reusable/modal";

const NewBed = ({ toggle, visible, onPerform }) => {
  const [name, setName] = useState();
  const [phone, setPhone] = useState();
  const [username, setUserName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [conf, setConf] = useState();
  const [date, setDate] = useState();

  const [roles, setRoles] = useState([]);
  const [role, setRole] = useState();

  const [superUser, toggleSuperUser] = useToggle();

  const { enqueueSnackbar } = useSnackbar();

  const modify = (e) => {
    switch (e.target.name) {
      case "name":
        setName(e.target.value);
        break;

      case "phone":
        setPhone(e.target.value);
        break;

      case "username":
        setUserName(e.target.value);
        break;

      case "email":
        setEmail(e.target.value);
        break;

      case "password":
        setPassword(e.target.value);
        break;

      case "conf":
        setConf(e.target.value);
        break;

      default:
        break;
    }
  };

  const onComplete = ({ data }, notif, ops) => {
    onPerform(data);
    notif("User has been added", ops("success"));

    setTimeout(toggle, 300);
  };

  const [{ loading }, execute] = usePet(
    "newUser",
    {
      name,
      phone,
      username,
      email,
      password: password?.toString(),
      superUser,
      role: role?.value,
    },
    { notify: true, callback: onComplete, manual: true }
  );

  usePet(
    "roles",
    { limit: 100 },
    {
      notify: true,
      callback: async ({ data }) => {
        setRoles(
          data?.roles?.map((store) => ({
            label: store.name,
            value: store._id,
          }))
        );
      },
    }
  );

  return (
    <Modal
      w={ 450 }
      title="New Bed"
      toggle={toggle}
      visible={visible}>
      <div className="divide-y divide-light-gray-400">
        <div>
          <p className="font-bold my-3">Bed Details</p>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-name"
              >
                Bed No
              </label>
              <input
                onChange={modify}
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-first-name"
                type="number"
                value={name}
                name="name"
                placeholder="001"
              />
            </div>
            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-name"
              >
                Ward
              </label>
              <input
                onChange={modify}
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-phone"
                type="text"
                value={phone}
                name="phone"
                placeholder="Muthiga"
              />
            </div>
          </div>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-username"
              >
                Added By
              </label>
              <input
                value={username}
                onChange={modify}
                name="username"
                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-username"
                type="text"
                placeholder="dickson"
              />
            </div>
            <div className="w-full md:w-2/3 px-3">
              <label
                className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                htmlFor="grid-email"
              >
                Date
              </label>
              <Datepicker value={ email } onChange={ setDate } /> 
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-4">
        <button
          disabled={loading}
          onClick={() => {
            if (conf === password) {
              execute();
            } else {
              enqueueSnackbar(
                "Please ensure that your password match",
                notifOps("warning")
              );
            }
          }}
          type="submit"
          className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          Add New Bed
        </button>
      </div>
    </Modal>
  );
};

export default NewBed;
